module.exports = {
  nav: {
    sourseClassify: "课程分类",
    organClassify: "机构分类",
    broadcastLive: "最近直播",
    certificateQuery: "证书查询",
    downloadApp: "下载APP",
    importor: "成为知识提供者",
    train: "培训"
  },
  sideBar: {
    IT: "IT互联网",
    upgrade: "升学考研",
    hobby: "兴趣生活",
    college: "学院",
    peojectManage: "项目管理",
    marketing: "企业营销",
    productManage: "产品经理"
  },
  session: {
    recommendOrgan: "推荐机构",
    all: "全部",
    broadcastLive: "最近直播",
    recommendCourse: "推荐课程"
  },
  footer: {
    aboutUs: "关于我们",
    joinInvestment: "招商加盟",
    contactUs: "联系我们",
    weChart: "微信",
    weiBo: "微博",
    shouji: "下载",
    address: "地址",
    msg:
      "蜀ICP备11021853号-2 Copyright @ 2008-2018 四川易极天成科技集团有限公司 All Rights Reserved"
  },
  centerBar: {
    myCourse: "我的课程",
    myCollect: "我的收藏",
    studyInterest: "学习兴趣",
    myAuth: "我的认证",
    myExam: "我的考试",
    growthRecord: "成长记录",
    myOrder: "我的订单",
    messageCenter: "消息中心"
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/zh.js